import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { RouterModule } from "@angular/router";
import { Constantes } from "src/app/shared/constantes";
import { SigtUtilisateurService } from "src/app/shared/services/sigt-utilisateur.service";
import { ZzzConfigService } from "src/app/zzz/core/config/config.service";
import { ZzzSecuriteService } from "src/app/zzz/securite/shared/securite.service";
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'sigt-menus',
    templateUrl: 'sigt-menus.component.html',
    styleUrls: ['./sigt-menus.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        TranslateModule
    ]
})
export class SigtMenusComponent {
  #securityService = inject(ZzzSecuriteService);
  #configService = inject(ZzzConfigService);
  #utilisateurService = inject(SigtUtilisateurService);

  connecter(): void {
    this.#securityService.redirectToProvider().subscribe();
  }

  deconnecter(): void {
    this.#securityService.deconnecter().subscribe();
  }

  isConnected(): boolean {
    return this.#securityService.utilisateurEstAuthentifie;
  }

  isPilote(): boolean {
    return this.#securityService.hasRole(Constantes.Roles.Pilote);
  }

  isNotInBaseRole(): boolean {
    return this.#securityService.doesNotHaveRole(Constantes.Roles.RU_ACCES_INTRA_SIG);
  }

  isIntranet(): boolean {
    return this.#configService.get().estIntranet;
  }

  isRegistered(): boolean {
    return this.#utilisateurService.current.id !== -1;
  }
}
